export const getInitialFormData = (investment) => ({
  name: investment?.name || '',
  type: investment?.type || '',
  amount: investment?.amount?.toString() || '',
  current_value: investment?.current_value?.toString() || '',
  currency: investment?.currency || 'USD',
  institution: investment?.institution || '',
  country: investment?.country || '',
  owner_type: investment?.owner_type || 'direct',
  entity_id: investment?.entity_id || '',
  ticker_symbol: investment?.ticker_symbol || '',
  stock_exchange: investment?.stock_exchange || '',
  maturity_date: investment?.maturity_date ? new Date(investment.maturity_date).toISOString().split('T')[0] : '',
  interest_rate: investment?.interest_rate?.toString() || '',
  face_value: investment?.face_value?.toString() || '',
  coupon_frequency: investment?.coupon_frequency || 'semi_annual',
  tenor: investment?.tenor || '',
  fund_manager: investment?.fund_manager || '',
  mutual_fund_type: investment?.mutual_fund_type || '',
  risk_rating: investment?.risk_rating || '',
  conversion_ratio: investment?.conversion_ratio?.toString() || '',
  discount_rate: investment?.discount_rate?.toString() || '',
  valuation_cap: investment?.valuation_cap?.toString() || '',
  valuation_cap_type: investment?.valuation_cap_type || 'pre_money',
  wallet_address: investment?.wallet_address || '',
  issuer_name: investment?.issuer_name || '',
  number_of_shares: investment?.number_of_shares?.toString() || '',
  share_price: investment?.share_price?.toString() || '',
  purchase_date: investment?.purchase_date ? new Date(investment.purchase_date).toISOString().split('T')[0] : new Date().toISOString().split('T')[0],
  notes: investment?.notes || '',
  property_country: investment?.property_country || '',
  property_city: investment?.property_city || '',
  property_street_address: investment?.property_street_address || '',
  property_type: investment?.property_type || '',
  property_date_acquired: investment?.property_date_acquired ? new Date(investment.property_date_acquired).toISOString().split('T')[0] : '',
  property_purchase_price: investment?.property_purchase_price?.toString() || '',
  property_current_market_price: investment?.property_current_market_price?.toString() || '',
  property_mortgage_outstanding: investment?.property_mortgage_outstanding?.toString() || '',
  etf_type: investment?.etf_type || '',
  etf_isin: investment?.etf_isin || '',
  etf_index_tracked: investment?.etf_index_tracked || '',
  etf_units: investment?.etf_units?.toString() || '',
  etf_purchase_price_per_unit: investment?.etf_purchase_price_per_unit?.toString() || '',
  etf_current_nav: investment?.etf_current_nav?.toString() || '',
  etf_fund_manager: investment?.etf_fund_manager || '',
  etf_fund_sponsor: investment?.etf_fund_sponsor || '',
  gold_purity_karats: investment?.gold_purity_karats || '',
  gold_form: investment?.gold_form || '',
  gold_weight_oz: investment?.gold_weight_oz?.toString() || '',
  gold_purchase_price_per_oz: investment?.gold_purchase_price_per_oz?.toString() || '',
  gold_current_price_per_oz: investment?.gold_current_price_per_oz?.toString() || '',
  gold_storage_location: investment?.gold_storage_location || ''
});
